import styled from "styled-components";
export const ModalFieldset = styled.fieldset.withConfig({ displayName: "ModalFieldset", componentId: "-gp9tpw" }) `
  && {
    padding-inline: 0;
  }
`;
